import { shallowEqual } from 'react-redux';
import { useSsSelector } from '~SpectateStore';
import {
    selectTournamentLogosByEventId,
    selectTournamentSlugByEventId,
    selectShowTeamLogo,
    selectShowAwayJersey,
} from '~SpectateStore/selectors/tournamentsSelectors';

export const useTournamentLogosByEventId = eventId => useSsSelector(state => selectTournamentLogosByEventId(state, eventId), shallowEqual);
export const useTournamentSlugByEventId = eventId => useSsSelector(state => selectTournamentSlugByEventId(state, eventId));

export const useShowTeamLogo = eventId => useSsSelector(state => selectShowTeamLogo(state, eventId));
export const useShowAwayJersey = eventId => useSsSelector(state => selectShowAwayJersey(state, eventId));
